module.exports = __webpack_public_path__ + "img/types-of-service-bg.3432fdfa.png";